export const LOAN_CONTENTFUL_SPACE = 'wty1of9m9psc';
